import { TextAreaInput } from "@/components/ui/forms/textareaInput"
import { type BoxFormPageProps } from "@modules/box/components/boxCreationForm/boxFormFirstPage"
import { BoxFormTemplatePage } from "@modules/box/components/boxCreationForm/boxFormTemplatePage"
import { word } from "@modules/core/utils/i18n"

export const BoxFormFifthPage = ({
  handleSubmit,
  onPrevious,
  formik,
  getFormErrorMessage,
  disabled,
}: BoxFormPageProps) => {
  return (
    <BoxFormTemplatePage
      onPrevious={onPrevious}
      handleSubmit={handleSubmit}
      disabled={disabled}
      pageNumber={5}
      header={{
        title: word("box.creation.page.5.title"),
        description: `${word("box.creation.page.5.description.1")} \n ${word("box.creation.page.5.description.2")}`,
      }}
    >
      <TextAreaInput
        isRequiredInput
        label={word("box.form.description.label")}
        setFieldValue={formik.setFieldValue}
        getFieldProps={formik.getFieldProps}
        name="description"
        error={getFormErrorMessage("description")}
        textareaProps={{
          onChange: (e) => {
            formik.setFieldValue("description", e.target.value)
          },
          className: "field-sizing-fixed",
          placeholder: word("box.form.description.label"),
          rows: 12,
        }}
      />
    </BoxFormTemplatePage>
  )
}
